import React, { useEffect, useLayoutEffect, useMemo } from "react";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { useDispatch, useSelector } from "react-redux";
import { extractActiveFilters } from "features/Filters/utils";
import { useLocation } from "react-router-dom";
import { setBreadcrumbTitle } from "features/breadcrumb/breadcrumbSlice";

import ContentGrid from "features/category/ContentGrid";
import ContentTopSection from "features/category/ContentTopSection";
import Pagination from "features/pagination";
import {
  selectPage,
  selectTotalItems,
  setPage,
} from "features/pagination/paginationSlice";
import { colors } from "theme/Theme";
import {
  fetchSearchedProducts,
  searchSelectors,
} from "features/searchBar/searchSlice";
import SearchCard from "./SearchCard";
import { useState } from "react";
import { getURLSearch } from "features/utils";

const SearchPage: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const page = useSelector(selectPage);
  const queryParams = new URLSearchParams(location.search);
  const filteredProducts = useSelector(searchSelectors.searchResultForPage);
  const productsLoading = useSelector(searchSelectors.selectLoading);
  const activeCategorySortingType = useSelector(
    searchSelectors.selectActiveSortingType
  );
  const totalItems = useSelector(selectTotalItems);
  var activeFilters = useMemo(
    () => extractActiveFilters(queryParams),
    [queryParams]
  );
  const [firstRerender, setFirstRerender] = useState<boolean>(false);

  useEffect(() => {
    const pageParam = queryParams.get("page");
    if (!pageParam) {
      setFirstRerender(!firstRerender);
      const searchURL = getURLSearch();
      dispatch(setPage(1));
      window.history.replaceState(
        null,
        "Търсене",
        `?page=${1}${searchURL !== "" ? `&${searchURL}` : ""}`
      );
    } else {
      dispatch(
        fetchSearchedProducts(activeFilters, page, activeCategorySortingType)
      );
    }
  }, [firstRerender, page, location, activeCategorySortingType]);

  useLayoutEffect(() => {
    dispatch(setBreadcrumbTitle("Климатици"));
    return () => {
      dispatch(setBreadcrumbTitle(""));
    };
  }, []);

  return (
    <>
      <PromoTitle className="text-lg">Резултат от вашето търсене</PromoTitle>

      <CategoryContainer>
        <ContentContainer>
          <ContentTopSection
            itemsLength={
              productsLoading && filteredProducts.length === 0 ? 0 : totalItems
            }
            isFromSearch={true}
          />

          <ContentGrid
            data={filteredProducts}
            ComponentToRender={SearchCard}
            isLoading={productsLoading}
          />
          {filteredProducts.length > 0 && (
            <Pagination disabled={productsLoading} />
          )}
        </ContentContainer>
      </CategoryContainer>
    </>
  );
};

const CategoryContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  padding: 16px 0 30px;
  justify-content: center;

  @media only screen and (${device.tablet}) {
    padding-top: 30px;
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-flow: column;
  width: 290px;
  max-width: 290px;
  padding-left: 10px;
`;

const ContentContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 0 12px;

  @media only screen and (${device.tablet}) {
    padding: 0 20px;
  }
`;

const PromoTitle = styled.div`
  color: ${colors.blue};
  text-align: center;
  font-weight: bold;
  padding: 10px 20px;
  @media only screen and (${device.tablet}) {
    padding: 20px 40px;
  }
`;

export default SearchPage;
